<template>
  <div
    v-loading="lockStatus"
    element-loading-text="数据加载中......"
    element-loading-spinner="el-icon-loading"
  >
    <el-row :gutter="5" class="page">
      <el-col :xs="16" :md="16">
        <corner-box class="box-element left-box">
          <div class="box-title">报警监测</div>
          <div class="type-box">
            <button class="default" v-for="item in dataType" :key="item.name" :class="{ primary: item.selected }" @click="selectDataType(item)">
              {{ item.name }}
            </button>
          </div>
          <div class="table-box1">
            <el-table :data="tableData1" :show-header="false" v-if="titleName=='AHU'">
              <el-table-column prop="name"></el-table-column>
              <el-table-column prop="value">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.name=='盘管温度(℃)'||scope.row.name=='湿度(%)'"
                  >{{ scope.row.value }}</div>
                  <div
                    v-else-if="scope.row.value == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name2"></el-table-column>
              <el-table-column prop="value2">
                <template slot-scope="scope">
                   <div
                    v-if="scope.row.name2=='冷凝温度(℃)'||scope.row.name2=='交流电压(V)'"
                  >{{ scope.row.value2 }}</div>
                  <div
                    v-else-if="scope.row.value2 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value2 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value2 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name3"></el-table-column>
              <el-table-column prop="value3">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.name3=='室内温度(℃)'||scope.row.name3=='直流电压(V)'"
                  >{{ scope.row.value3 }}</div>
                  <div
                    v-else-if="scope.row.value3 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value3 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value3 }}</div>
                </template>
              </el-table-column>
            </el-table>
            <el-table :data="tableData2" :show-header="false" v-else-if="titleName=='PCS'">
              <el-table-column prop="name"></el-table-column>
              <el-table-column prop="value">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.name=='散热器温度(℃)'||scope.row.name=='交流频率(Hz)'||scope.row.name=='当前容量(kW·h)'||scope.row.name=='PV母线功率(kW)'||scope.row.name=='直流电流(A)'||scope.row.name=='母线电压(V)'"
                  >{{ scope.row.value }}</div>
                  <div
                    v-else-if="scope.row.value == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name2"></el-table-column>
              <el-table-column prop="value2">
                <template slot-scope="scope">
                 <div
                    v-if="scope.row.name2=='机柜温度(℃)'||scope.row.name2=='有功功率设置(kW)'||scope.row.name2=='PV母线电压(V)'||scope.row.name2=='直流功率(kW)'||scope.row.name2=='直流电流设置(A)'"
                  >{{ scope.row.value2 }}</div>
                  <div
                    v-else-if="scope.row.value2 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value2 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value2 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name3"></el-table-column>
              <el-table-column prop="value3">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.name3=='环境温度(℃)'||scope.row.name3=='无功功率设置(kVar)'||scope.row.name3=='PV母线电流(A)'||scope.row.name3=='直流电压(V)'||scope.row.name3=='直流功率设置(kW)'"
                  >{{ scope.row.value3 }}</div>
                  <div
                    v-else-if="scope.row.value3 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value3 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value3 }}</div>
                </template>
              </el-table-column>
            </el-table>
            <el-table :data="tableData3" :show-header="false" v-else-if="titleName=='PCS-AC'">
              <el-table-column prop="name"></el-table-column>
              <el-table-column prop="value">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.value == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name2"></el-table-column>
              <el-table-column prop="value2">
                <template slot-scope="scope">
                 <div
                    v-if="scope.row.value2 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value2 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value2 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name3"></el-table-column>
              <el-table-column prop="value3">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.value3 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value3 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value3 }}</div>
                </template>
              </el-table-column>
            </el-table>
            <el-table :data="tableData4" :show-header="false"  v-else-if="titleName=='PCS-DC'">
              <el-table-column prop="name"></el-table-column>
              <el-table-column prop="value">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.value == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name2"></el-table-column>
              <el-table-column prop="value2">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.value2 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value2 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value2 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name3"></el-table-column>
              <el-table-column prop="value3">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.value3 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value3 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value3 }}</div>
                </template>
              </el-table-column>
            </el-table>
            <el-table :data="tableData5" :show-header="false" v-else-if="titleName=='PCS-STS'">
              <el-table-column prop="name"></el-table-column>
              <el-table-column prop="value">
                <template slot-scope="scope">
                 <div
                    v-if="scope.row.value == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name2"></el-table-column>
              <el-table-column prop="value2">
                <template slot-scope="scope">
                 <div
                    v-if="scope.row.value2 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value2 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value2 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="name3"></el-table-column>
              <el-table-column prop="value3">
                <template slot-scope="scope">
                 <div
                    v-if="scope.row.value3 == 1"
                    style="width:50px;height:15px;background:red;margin-left:35px;border-radius:10px"
                  ></div>
                  <div
                    v-else-if="scope.row.value3 == 0"
                    style="width:50px;height:15px;background:green;margin-left:35px;border-radius:10px"
                  ></div>
                  <div v-else>{{ scope.row.value3 }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </corner-box>
      </el-col>
      <el-col :xs="8" :md="8">
        <corner-box class="top-box box-element">
          <div class="box-title">设置量</div>
          <div class="table-box2">
            <el-table :data="tableData6" :show-header="false">
              <el-table-column prop="name"></el-table-column>
              <el-table-column prop="value"></el-table-column>
            </el-table>
          </div>
        </corner-box>
        <corner-box class="bottom-box box-element">
          <el-table class="table-box3" :data="tableData7" :show-header="false">
            <el-table-column prop="name"></el-table-column>
            <el-table-column prop="value">
              <template slot-scope="scope">
                <div
                  v-if="scope.row.value == 0"
                  style="width:50px;height:15px;background:green;margin-left:90px;border-radius:10px"
                ></div>
                <div
                  v-else-if="scope.row.value == 1"
                  style="width:50px;height:15px;background:red;margin-left:90px;border-radius:10px"
                ></div>
                <div
                  v-else
                >{{ scope.row.value }}</div>
              </template>
            </el-table-column>
          </el-table>
        </corner-box>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import cornerBox from "../../../components/cornerBox";
export default {
  name: "pvEnergyStorageAlarm",
  components:{
    cornerBox
  },
  data() {
    return {
      lockStatus: "",
      titleName: "AHU",
      dataType: [
        { name: "AHU", selected: true },
        { name: "PCS", selected: false },
        { name: "PCS-AC", selected: false },
        { name: "PCS-DC", selected: false },
        { name: "PCS-STS", selected: false }
      ],
      tableData1: [{
        name: '盘管温度(℃)',
        value: 'TG233:b5_b1-ac_pgwd',
        name2: '冷凝温度(℃)',
        value2: 'TG233:b5_b1-ac_ljwd',
        name3: '室内温度(℃)',
        value3: 'TG233:b5_b1-ac_snwd',
        }, {
        name: '湿度(%)',
        value: 'TG233:b5_b1-ac_sd',
        name2: '交流电压(V)',
        value2: 'TG233:b5_b1-ac_acjldy',
        name3: '直流电压(V)',
        value3: 'TG233:b5_b1-ac_aczldy'
        }, {
        name: '高温告警',
        value: 'TG233:b5_b1-ac_gwgj',
        name2: '湿感失效',
        value2: 'TG233:b5_b1-ac_sgsx',
        name3: '高压锁定',
        value3: 'TG233:b5_b1-ac_gysd'
        }, {
        name: '低温告警',
        value: 'TG233:b5_b1-ac_dwgj',
        name2: '内风机故障',
        value2: 'TG233:b5_b1-ac_nfjgz',
        name3: '低压锁定',
        value3: 'TG233:b5_b1-ac_dysd'
        }, {
        name: '高湿告警',
        value: 'TG233:b5_b1-ac_gsgj',
        name2: '外风机故障',
        value2: 'TG233:b5_b1-ac_wfjgz',
        name3: '排气锁定',
        value3: 'TG233:b5_b1-ac_pqsd'
        }, {
        name: '低湿告警',
        value: 'TG233:b5_b1-ac_dsgj',
        name2: '压缩机故障',
        value2: 'TG233:b5_b1-ac_ysjgz',
        name3: '交流过压',
        value3: 'TG233:b5_b1-ac_jlgy'
        }, {
        name: '盘管防冻',
        value: 'TG233:b5_b1-ac_pgfd',
        name2: '电加热故障',
        value2: 'TG233:b5_b1-ac_djrgz',
        name3: '交流欠压',
        value3: 'TG233:b5_b1-ac_jlqy'
        }, {
        name: '排气高温',
        value: 'TG233:b5_b1-ac_pqgw',
        name2: '应急风机故障',
        value2: 'TG233:b5_b1-ac_yjfjgz',
        name3: '交流掉电',
        value3: 'TG233:b5_b1-ac_jldd'
        }, {
        name: '盘管温感失效',
        value: 'TG233:b5_b1-ac_pgwgsx',
        name2: '高压告警',
        value2: 'TG233:b5_b1-ac_gygj',
        name3: '缺相',
        value3: 'TG233:b5_b1-ac_qx'
        },{
        name: '室外温感失效',
        value: 'TG233:b5_b1-ac_swwgsx',
        name2: '低压告警',
        value2: 'TG233:b5_b1-ac_dygj',
        name3: '频率异常',
        value3: 'TG233:b5_b1-ac_plyc'
        },{
        name: '冷凝温感失效',
        value: 'TG233:b5_b1-ac_lnwgsx',
        name2: '水浸告警',
        value2: 'TG233:b5_b1-ac_sj',
        name3: '逆相',
        value3: 'TG233:b5_b1-ac_nx'
        },{
        name: '内温感失效',
        value: 'TG233:b5_b1-ac_nwgsx',
        name2: '烟感告警',
        value2: 'TG233:b5_b1-ac_yggj',
        name3: '直流过压',
        value3: 'TG233:b5_b1-ac_zlgy'
        },{
        name: '排气温感失效',
        value: 'TG233:b5_b1-ac_pqgwsx',
        name2: '门禁告警',
        value2: 'TG233:b5_b1-ac_mjgj',
        name3: '直流欠压',
        value3: 'TG233:b5_b1-ac_zlqy'
      }],
      tableData2: [{
        name: '散热器温度(℃)',
        value: 'TG233:b5_b1-pcs_srqwd',
        name2: '机柜温度(℃)',
        value2: 'TG233:b5_b1-pcs_jgwd',
        name3: '环境温度(℃)',
        value3: 'TG233:b5_b1-pcs_hjwd',
        }, {
        name: '交流频率(Hz)',
        value: 'TG233:b5_b1-pcs_f',
        name2: '有功功率设置(kW)',
        value2: 'TG233:b5_b1-pcs_psz',
        name3: '无功功率设置(kVar)',
        value3: 'TG233:b5_b1-pcs_qsz'
        }, {
        name: '当前容量(kW·h)',
        value: 'TG233:b5_b1-pcs_dqrl',
        name2: 'PV母线电压(V)',
        value2: 'TG233:b5_b1-pcs_pv-u',
        name3: 'PV母线电流(A)',
        value3: 'TG233:b5_b1-pcs_pv-i'
        },{
        name: 'PV母线功率(kW)',
        value: 'TG233:b5_b1-pcs_pv-s',
        name2: '直流功率(kW)',
        value2: 'TG233:b5_b1-pcs_pzl',
        name3: '直流电压(V)',
        value3: 'TG233:b5_b1-pcs_uzl'
        },{
        name: '直流电流(A)',
        value: 'TG233:b5_b1-pcs_izl',
        name2: '直流电流设置(A)',
        value2: 'TG233:b5_b1-pcs_izlsz',
        name3: '直流功率设置(kW)',
        value3: 'TG233:b5_b1-pcs_szlsz'
        },{
        name: '母线电压(V)',
        value: 'TG233:b5_b1-pcs_umx',
        name2: '光伏欠压',
        value2: 'TG233:b5_b1-pcs_gfqy',
        name3: '通讯异常',
        value3: 'TG233:b5_b1-pcs_txyc'
        },{
        name: '后台通讯异常',
        value: 'TG233:b5_b1-pcs_httxyc',
        name2: '系统启停状态',
        value2: 'TG233:b5_b1-pcs_xtqtzt',
        name3: '系统待机状态',
        value3: 'TG233:b5_b1-pcs_xtdjzt'
        } ,{
        name: '系统并网',
        value: 'TG233:b5_b1-pcs_xtbw',
        name2: '系统离网',
        value2: 'TG233:b5_b1-pcs_xtlw',
        name3: '本地手动控制',
        value3: 'TG233:b5_b1-pcs_bdsdkz'
        },{
        name: '本地自动控制',
        value: 'TG233:b5_b1-pcs_bdzdkz',
        name2: '远程控制',
        value2: 'TG233:b5_b1-pcs_yckz',
        name3: '锁定退出',
        value3: 'TG233:b5_b1-pcs_sdtc'
        },{
        name: '交流调度状态',
        value: 'TG233:b5_b1-pcs_jlddzt',
        name2: '直流调度状态',
        value2: 'TG233:b5_b1-pcs_zlddzt',
        name3: '电压频率穿越状态',
        value3: 'TG233:b5_b1-pcs_dyplcyzt'
        },{
        name: '孤岛检测状态',
        value: 'TG233:b5_b1-pcs_gdjczt',
        name2: '交流开关状态',
        value2: 'TG233:b5_b1-pcs_jlkgzt',
        name3: '系统告警',
        value3: 'TG233:b5_b1-pcs_xtgj'
        },{
        name: '系统故障',
        value: 'TG233:b5_b1-pcs_xtgz',
        name2: '光伏母线开关状态',
        value2: 'TG233:b5_b1-pcs_gfmxkgzt',
        name3: 'DSP初始化完成状态',
        value3: 'TG233:b5_b1-pcs_dspcshwczt'
        },{
        name: '总功率因数',
        value: 'TG233:b5_b1-pcs_pf',
        name2: '充满状态',
        value2: 'TG233:b5_b1-pcs_cmzt',
        name3: '放空状态',
        value3: 'TG233:b5_b1-pcs_fkzt'
        },{
        name: '充电状态',
        value: 'TG233:b5_b1-pcs_cdzt',
        name2: '放电状态',
        value2: 'TG233:b5_b1-pcs_fdzt',
        name3: '光伏发电状态',
        value3: 'TG233:b5_b1-pcs_gffdzt'
        },{
        name: '光伏休眠状态',
        value: 'TG233:b5_b1-pcs_gfxmzt',
        name2: '恒压均充',
        value2: 'TG233:b5_b1-pcs_hyjc',
        name3: '恒压浮充',
        value3: 'TG233:b5_b1-pcs_hyfc'
        },{
        name: '直流开关状态',
        value: 'TG233:b5_b1-pcs_zlkgzt',
        name2: 'MPPT工作状态',
        value2: 'TG233:b5_b1-pcs_mpptgzzt',
        name3: '启停状态',
        value3: 'TG233:b5_b1-pcs_qtzt'
        },{
        name: '待机状态',
        value: 'TG233:b5_b1-pcs_djzt',
        }],
      tableData3: [{
        name: ' AC交流过压',
        value: 'TG233:b5_b1-pcs_ac-jlgy',
        name2: 'AC交流过频',
        value2: 'TG233:b5_b1-pcs_ac-jlgp',
        name3: 'AC交流欠压',
        value3: 'TG233:b5_b1-pcs_ac-jlqy',
        }, {
        name: 'AC逆变器孤岛',
        value: 'TG233:b5_b1-pcs_ac-nbqgd',
        name2: 'AC直流输入过压',
        value2: 'TG233:b5_b1-pcs_ac-zlsrgy',
        name3: 'AC并离网切换异常',
        value3: 'TG233:b5_b1-pcs_ac-blwqhyc'
        }, {
        name: 'AC交流反序',
        value: 'TG233:b5_b1-pcs_ac-jlfx',
        name2: 'AC直流电压低',
        value2: 'TG233:b5_b1-pcs_ac-zldygd',
        name3: 'AC输出过载',
        value3: 'TG233:b5_b1-pcs_ac-scgz'
        }, {
        name: 'AC输出电压异常',
        value: 'TG233:b5_b1-pcs_ac-scdyyc',
        name2: 'AC交流缺相',
        value2: 'TG233:b5_b1-pcs_ac-jlqx',
        name3: 'AC电网电压不平衡',
        value3: 'TG233:b5_b1-pcs_ac-dwdybph'
        }, {
        name: 'AC交流欠频',
        value: 'TG233:b5_b1-pcs_ac-jlqp',
        name2: 'AC微网电池能量低',
        value2: 'TG233:b5_b1-pcs_ac-wwdcnld',
        name3: 'AC微网光伏能量低',
        value3: 'TG233:b5_b1-pcs_acwwgfnld'
        }, {
        name: 'AC离网电压反序',
        value: 'TG233:b5_b1-pcs_ac-lwdyfx',
        name2: 'AC电网锁相失败',
        value2: 'TG233:b5_b1-pcs_ac-dwsxsb',
        name3: 'AC环境温度过温',
        value3: 'TG233:b5_b1-pcs_ac-hjwdgw'
        }, {
        name: 'AC环温探头故障',
        value: 'TG233:b5_b1-pcs_ac-hwttgz',
        name2: 'AC柜温探头故障',
        value2: 'TG233:b5_b1-pcs_ac-gwttgz',
        name3: 'AC机柜温度过温',
        value3: 'TG233:b5_b1-pcs_ac-jgwdgw'
        }, {
        name: 'AC离网电压缺相',
        value: 'TG233:b5_b1-pcs_ac-lwdyqx',
        name2: 'AC 24V电源故障',
        value2: 'TG233:b5_b1-pcs_ac-24vdygz',
        name3: 'AC紧急停机',
        value3: 'TG233:b5_b1-pcs_ac-jjtj'
        }, {
        name: 'AC直流接地故障',
        value: 'TG233:b5_b1-pcs_ac-zljdgz',
        name2: 'AC母线过压',
        value2: 'TG233:b5_b1-pcs_ac-mxgy',
        name3: 'AC逆变器过温',
        value3: 'TG233:b5_b1-pcs_ac-nbqgw'
        }, {
        name: 'AC模块电流不平衡',
        value: 'TG233:b5_b1-pcs_ac-mkdlbph',
        name2: 'AC风扇故障',
        value2: 'TG233:b5_b1-pcs_ac-fsgz',
        name3: 'AC直流继电器开路',
        value3: 'TG233:b5_b1-pcs_ac-zljdqkl'
        }, {
        name: 'AC校正参数异常',
        value: 'TG233:b5_b1-pcs_ac-jzcsyc',
        name2: 'AC母线平衡异常',
        value2: 'TG233:b5_b1-pcs_ac-mxphyc',
        name3: 'AC保险故障',
        value3: 'TG233:b5_b1-pcs_ac-bxgz'
        }, {
        name: 'AC监控参数设置故障',
        value: 'TG233:b5_b1-pcs_ac-jkcsszgz',
        name2: 'AC直流软启动失败',
        value2: 'TG233:b5_b1-pcs_ac-zlrqdsb',
        name3: 'AC CAN A通信故障',
        value3: 'TG233:b5_b1-pcs_ac-canatxgz'
        }, {
        name: 'AC输出接地故障',
        value: 'TG233:b5_b1-pcs_ac-scjdgz',
        name2: ' AC二极管过温',
        value2: 'TG233:b5_b1-pcs_ac-ejggw',
        name3: 'AC变压器过温',
        value3: 'TG233:b5_b1-pcs_ac-byagw'
        }, {
        name: 'AC U2通信异常2',
        value: 'TG233:b5_b1-pcs_ac-u2txyc2',
        name2: 'AC BMS故障',
        value2: 'TG233:b5_b1-pcs_ac-bmsgz',
        name3: 'AC防雷器故障',
        value3: 'TG233:b5_b1-pcs_ac-flqgz'
        }, {
        name: 'AC输出过载超时',
        value: 'TG233:b5_b1-pcs_ac-scgzcs',
        name2: 'AC交流软启动失败',
        value2: 'TG233:b5_b1-pcs_ac-jlrqdsb',
        name3: 'AC同步信号故障1',
        value3: 'TG233:b5_b1-pcs_ac-tbxhgz1'
        }, {
        name: 'AC DSP版本故障',
        value: 'TG233:b5_b1-pcs_ac-dspbbgz',
        name2: 'AC交流继电器开路',
        value2: 'TG233:b5_b1-pcs_ac-jljdqkl',
        name3: 'AC采样零点异常',
        value3: 'TG233:b5_b1-pcs_ac-cyldyc'
        }, {
        name: 'AC U2通信异常1',
        value: 'TG233:b5_b1-pcs_ac-u2txyc',
        name2: 'AC 15V电源故障',
        value2: 'TG233:b5_b1-pcs_ac-15vdygz',
        name3: 'AC模块重号故障',
        value3: 'TG233:b5_b1-pcs_ac-mkchgz'
        }, {
        name: 'AC 485通信故障',
        value: 'TG233:b5_b1-pcs_ac-485txgz',
        name2: 'AC CAN B通信故障',
        value2: 'TG233:b5_b1-pcs_ac-canbtxgz',
        name3: 'AC主机冲突故障',
        value3: 'TG233:b5_b1-pcs_ac-zjctgz'
        }, {
        name: 'AC CPLD版本故障',
        value: 'TG233:b5_b1-pcs_ac-cpldbbgz',
        name2: 'AC硬件版本故障',
        value2: 'TG233:b5_b1-pcs_ac-yjbbgz',
        name3: 'AC直流继电器短路',
        value3: 'TG233:b5_b1-pcs_ac-zljdqdl'
        }, {
        name: 'AC母线欠压',
        value: 'TG233:b5_b1-pcs_ac-mxqy',
        name2: 'AC交流继电器短路',
        value2: 'TG233:b5_b1-pcs_ac-jljdqdl',
        name3: 'AC同步信号故障2',
        value3: 'TG233:b5_b1-pcs_ac-tbxhgz2'
        }, {
        name: 'AC参数冲突故障',
        value: 'TG233:b5_b1-pcs_ac-csctgz',
        name2: 'AC CAN C通信故障',
        value2: 'TG233:b5_b1-pcs_ac-canctxgz',
        name3: 'AC 环境湿度过高',
        value3: 'TG233:b5_b1-pcs_ac-hjsdgg'
        }, {
        name: 'AC 支路BMS电压异常',
        value: 'TG233:b5_b1-pcs_ac-zlbmsdyyc',
        name2: 'AC 支路BMS电流异常',
        value2: 'TG233:b5_b1-pcs_ac-zlbmsdlyc',
        name3: 'AC 支路BMS温度异常',
        value3: 'TG233:b5_b1-pcs_ac-zlbmswdyc'
        }, {
        name: 'AC 支路BMS跳机异常',
        value: 'TG233:b5_b1-pcs_ac-zlbmstjyc'
      }],
      tableData4: [{
        name: 'DC母线过压',
        value: 'TG233:b5_b1-pcs_dc-mxgy',
        name2: 'DC母线欠压',
        value2: 'TG233:b5_b1-pcs_dc-muqy',
        name3: 'DC电池过压',
        value3: 'TG233:b5_b1-pcs_dc-dcgy'
        },{
        name: 'DC电池欠压',
        value: 'TG233:b5_b1-pcs_dc-dcqy',
        name2: 'DC电池过流',
        value2: 'TG233:b5_b1-pcs_dc-dcgl',
        name3: 'DC电池未接入',
        value3: 'TG233:b5_b1-pcs_dc-dcwjr'
        },{
        name: 'DC电池过载',
        value: 'TG233:b5_b1-pcs_dc-dcgz',
        name2: 'DC电池继电器短路',
        value2: 'TG233:b5_b1-pcs_dc-dcjdqdl',
        name3: 'DC微网光伏能量低',
        value3: 'TG233:b5_b1-pcs_dc-wwgfnld'
        },{
        name: 'DC微网电池能量低',
        value: 'TG233:b5_b1-pcs_dc-wwdcnld',
        name2: 'DC环境温度过温',
        value2: 'TG233:b5_b1-pcs_dc-hjwdgw',
        name3: 'DC BMS故障',
        value3: 'TG233:b5_b1-pcs_dc-bmsgz'
        },{
        name: 'DC U2通信异常1',
        value: 'TG233:b5_b1-pcs_dc-u2txyc1',
        name2: 'DC柜内温度过温',
        value2: 'TG233:b5_b1-pcs_dc-gnwdgw',
        name3: 'DC柜温探头故障',
        value3: 'TG233:b5_b1-pcs_dc-gwttgz'
        },{
        name: 'DC环温探头故障',
        value: 'TG233:b5_b1-pcs_dc-hwttgz',
        name2: 'DC模块电流不平衡',
        value2: 'TG233:b5_b1-pcs_dc-mkdlbph',
        name3: 'DC电池过温',
        value3: 'TG233:b5_b1-pcs_dc-dcgw'
        },{
        name: 'DC 24V电源故障',
        value: 'TG233:b5_b1-pcs_dc-24vdygz',
        name2: 'DC紧急停机',
        value2: 'TG233:b5_b1-pcs_dc-jjtj',
        name3: 'DC接地故障',
        value3: 'TG233:b5_b1-pcs_dc-jdgz'
        },{
        name: 'DC母线平衡故障',
        value: 'TG233:b5_b1-pcs_dc-mxphgz',
        name2: 'DC模块过温',
        value2: 'TG233:b5_b1-pcs_dc-mkgw',
        name3: 'DC风扇故障',
        value3: 'TG233:b5_b1-pcs_dc-fsgz'
        },{
        name: 'DC电池继电器开路',
        value: 'TG233:b5_b1-pcs_dc-dcjdqkl',
        name2: 'DC校准参数异常',
        value2: 'TG233:b5_b1-pcs_dc-jzcsyc',
        name3: 'DC保险故障',
        value3: 'TG233:b5_b1-pcs_dc-bxgz'
        },{
        name: 'DC监控设置故障',
        value: 'TG233:b5_b1-pcs_dc-jkszgz',
        name2: 'DC电池软启动失败',
        value2: 'TG233:b5_b1-pcs_dc-dcrqdsb',
        name3: 'DC CAN A通信故障',
        value3: 'TG233:b5_b1-pcs_dc-canatxgz'
        },{
        name: 'DC BUS继电器开路',
        value: 'TG233:b5_b1-pcs_dc-busjdqkl',
        name2: 'DC母线软启动失败',
        value2: 'TG233:b5_b1-pcs_dc-mxrqdsb',
        name3: 'DC DSP版本故障',
        value3: 'TG233:b5_b1-pcs_dc-dspbbgz'
        },{
        name: 'DC CPLD版本故障',
        value: 'TG233:b5_b1-pcs_dc-cpldbbgz',
        name2: 'DC参数冲突故障',
        value2: 'TG233:b5_b1-pcs_dc-csctgz',
        name3: 'DC硬件版本故障',
        value3: 'TG233:b5_b1-pcs_dc-yjbbgz'
        },{
        name: 'C 485通信故障',
        value: 'TG233:b5_b1-pcs_dc-485txgz',
        name2: 'DC CAN B通信故障',
        value2: 'TG233:b5_b1-pcs_dc-canbtxgz',
        name3: 'DC模块重号故障',
        value3: 'TG233:b5_b1-pcs_dc-mkchgz'
        },{
        name: 'DC主机冲突故障',
        value: 'TG233:b5_b1-pcs_dc-zjctgz',
        name2: 'DC 15V电源故障',
        value2: 'TG233:b5_b1-pcs_dc-15vdygz',
        name3: 'DC母线继电器短路',
        value3: 'TG233:b5_b1-pcs_dc-mxjdqdl'
        },{
        name: 'DC支路BMS电压异常',
        value: 'TG233:b5_b1-pcs_dc-zlbmsdyyc',
        name2: 'DC支路BMS电流异常',
        value2: 'TG233:b5_b1-pcs_dc-zlbmsdlyc',
        name3: 'DC支路BMS温度异常',
        value3: 'TG233:b5_b1-pcs_dc-zlbmswdyc'
        },{
        name: 'DC支路BMS跳机异常',
        value: 'TG233:b5_b1-pcs_dc-zlbmstjyc',
      }],
      tableData5: [{
        name: 'STS电网电压反序',
        value: 'TG233:b5_b1-pcs_sts-dwdyfx',
        name2: 'STS电网缺N',
        value2: 'TG233:b5_b1-pcs_sts-dwqn',
        name3: 'STS离网电压反序',
        value3: 'TG233:b5_b1-pcs_sts-lwdyfx'
        },{
        name: 'STS离网电压缺相',
        value: 'TG233:b5_b1-pcs_sts-lwdyqx',
        name2: 'STS校准参数告警',
        value2: 'TG233:b5_b1-pcs_sts-jzcsgj',
        name3: 'STS采样零点告警',
        value3: 'TG233:b5_b1-pcs_sts-cyldgj'
        } ,{
        name: 'STS输出过载',
        value: 'TG233:b5_b1-pcs_sts-scgz',
        name2: 'STS环境温度过温',
        value2: 'TG233:b5_b1-pcs_sts-hjwdgw',
        name3: 'STS锁相失败',
        value3: 'TG233:b5_b1-pcs_sts-sxsb'
        } ,{
        name: 'STS电网电压不平衡',
        value: 'TG233:b5_b1-pcs_sts-dwdybph',
        name2: 'STS电网侧欠压',
        value2: 'TG233:b5_b1-pcs_sts-dwcqy',
        name3: 'STS电网侧过压',
        value3: 'TG233:b5_b1-pcs_sts-dwcgy'
        } ,{
        name: 'STS电网侧欠频',
        value: 'TG233:b5_b1-pcs_sts-dwcqp',
        name2: 'STS电网侧过频',
        value2: 'TG233:b5_b1-pcs_sts-dwcgp',
        name3: 'STS频繁切换故障',
        value3: 'TG233:b5_b1-pcs_sts-pfqhgz'
        },{
        name: 'STS模值电压异常',
        value: 'TG233:b5_b1-pcs_sts-mzdyyc',
        name2: 'STS紧急停机故障',
        value2: 'TG233:b5_b1-pcs_sts-jjtjgz',
        name3: 'STS_15V电源故障',
        value3: 'TG233:b5_b1-pcs_sts-15vdygz'
        },{
        name: 'STS_24V电源故障',
        value: 'TG233:b5_b1-pcs_sts-24vdygz',
        name2: 'STS_CANA通讯故障',
        value2: 'TG233:b5_b1-pcs_sts-canatxgz',
        name3: 'STS_CANB通讯故障',
        value3: 'TG233:b5_b1-pcs_sts-canbtxgz'
        },{
        name: 'STS_485通讯故障',
        value: 'TG233:b5_b1-pcs_sts-485txgz',
        name2: 'STS_设置故障',
        value2: 'TG233:b5_b1-pcs_sts-szgz',
        name3: 'STS并网空开开路',
        value3: 'TG233:b5_b1-pcs_sts-bwkkkl'
        },{
        name: 'STS并网空开短路',
        value: 'TG233:b5_b1-pcs_sts-bwkkdl',
        name2: 'STS输出过载超时',
        value2: 'TG233:b5_b1-pcs_sts-scgzcs',
        name3: 'STS同步信号1故障',
        value3: 'TG233:b5_b1-pcs_sts-tbxh1gz'
        },{
        name: 'STS环境温度传感器',
        value: 'TG233:b5_b1-pcs_sts-hjwdcgq',
        name2: 'STS机柜温度传感器',
        value2: 'TG233:b5_b1-pcs_sts-jgwdcgq',
        name3: 'STS机柜过温',
        value3: 'TG233:b5_b1-pcs_sts-jggw'
        },{
        name: 'STS散热器过温',
        value: 'TG233:b5_b1-pcs_sts-srqgw',
        name2: 'STS风扇故障',
        value2: 'TG233:b5_b1-pcs_sts-fsgz',
        name3: 'STS_DSP版本故障',
        value3: 'TG233:b5_b1-pcs_sts-dspbbgz'
        },{
        name: 'STS_CPLD版本故障',
        value: 'TG233:b5_b1-pcs_sts-cpldbbgz',
        name2: 'STS旁路故障',
        value2: 'TG233:b5_b1-pcs_sts-plgz',
        name3: 'STS防雷器故障',
        value3: 'TG233:b5_b1-pcs_sts-flqgz'
        },{
        name: 'STS晶闸管温度传感器',
        value: 'TG233:b5_b1-pcs_sts-jzgwdcgq',
        name2: 'STS电网电压快检异常',
        value2: 'TG233:b5_b1-pcs_sts-dwdykjyc',
        name3: 'STS在线',
        value3: 'TG233:b5_b1-pcs_sts-zx'
        },{
        name: 'STS并网',
        value: 'TG233:b5_b1-pcs_sts-bw',
        name2: 'STS离网',
        value2: 'TG233:b5_b1-pcs_sts-lw',
        name3: 'STS系统告警',
        value3: 'TG233:b5_b1-pcs_sts-xtgj'
        },{
        name: 'STS系统故障',
        value: 'TG233:b5_b1-pcs_sts-xtgz'
      }],
      tableData6: [{
        name: '制冷点(℃)',
        value: 'TG233:b5_b1-ac_zld',
        },{
        name: '制冷回差(℃)',
        value: 'TG233:b5_b1-ac_zlhc',
        },{
        name: '加热点(℃)',
        value: 'TG233:b5_b1-ac_jrd',
        },{
        name: '加热回差(℃)',
        value: 'TG233:b5_b1-ac_jrhc',
        },{
        name: '高温点(℃)',
        value: 'TG233:b5_b1-ac_gwd',
        },{
        name: '低温点(℃)',
        value: 'TG233:b5_b1-ac_dwd',
        },{
        name: '高湿点(%)',
        value: 'TG233:b5_b1-ac_gsd',
        },{
        name: '内风机停止点(℃)',
        value: 'TG233:b5_b1-ac_nfjtzd',
      }],
      tableData7: [{
        name: '整机状态',
        value: 'TG233:b5_b1-ac_zjzt',
        },{
        name: '内风机',
        value: 'TG233:b5_b1-ac_nfj',
        },{
        name: '外风机',
        value: 'TG233:b5_b1-ac_wfj',
        },{
        name: '压缩机',
        value: 'TG233:b5_b1-ac_ysj',
        },{
        name: '电加热',
        value: 'TG233:b5_b1-ac_djr',
        },{
        name: '应急风机',
        value: 'TG233:b5_b1-ac_yjfj',
      }],
    };
  },
  created() {
      this.getData();
  },
  mounted() {
    this.timer = setInterval(this.getData, 2000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null
  },
  methods: {
    selectDataType(item) {
      this.dataType.forEach(function(i) {
        i.selected = false;
      });
      item.selected = true;
      this.titleName = item.name;
    },
    getData() {
      let params = {};
      // params.$projectId = "1";
      // params.$divisionId = "1";
      params.$deviceName = "TG233:b5_b1-ac,TG233:b5_b1-pcs";
      let $this = this;
      this.$get( "pvenergystoragealarm/qualifyandalaram" , params).then(
        (response) => {
          this.lockStatus = false;
          var obj = JSON.parse(JSON.stringify(response));
          this.findTag(this.tableData1 , obj);
          this.findTag(this.tableData2 , obj);
          this.findTag(this.tableData3 , obj);
          this.findTag(this.tableData4 , obj);
          this.findTag(this.tableData5 , obj);
          this.findTag(this.tableData6 , obj);
          this.findTag(this.tableData7 , obj);
        },
        (err) => {
          this.lockStatus = true;
        }
      )
    },
    findTag(tableData , res) {
      for( let i in tableData) {
        for( let key1 in tableData[i]) {
          if( key1 === "value" || key1 === "value2" || key1 === "value3") {
            for( let key2 in res) {
              if( tableData[i][key1] === key2) {
                tableData[i][key1] = res[key2];
              }
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.page {
  padding: 10px 5px 5px;
  .left-box {
    height: 780px;
    padding: 10px 15px 0;
    .type-box {
      margin: 10px 0 30px;
      .data-type {
        margin-right: 10px;
      }
    }
    .table-box1 {
      max-height: 641px;
      border-top: 1px solid #376cf2;
      overflow-y: auto;
    }
  }
  .top-box {
    height: 430px;
    padding: 9px 3px 0;
    margin-bottom: 5px;
    .table-box2 {
      margin: 40px 25px 0;
      border-top: 1px solid #376cf2;
    }
  }
  .bottom-box {
    padding: 40px 30px 0;
    height: 345px;
    .table-box3 {
      border-top: 1px solid #376cf2;
    }
  }
}
</style>
